"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Money = void 0;
const decimal_js_1 = require("decimal.js");
const enums_1 = require("./enums");
class Money {
    constructor(amount, currency) {
        this.amount = amount;
        this.currency = currency;
    }
    add(term) {
        if (typeof term === 'number')
            return this.addNumber(term);
        if (term.currency !== this.currency)
            throw new Error('Não é possível a adição de diferentes moedas!');
        return this.addNumber(term.amount);
    }
    addNumber(term) {
        const fixedTerm = new decimal_js_1.Decimal(term).toFixed(2);
        return new Money(decimal_js_1.Decimal.add(this.amount, fixedTerm).toNumber(), this.currency);
    }
    /**
     * Multiply a Money by a factor and returns a new Money instance.
     * @param factor A factor to multiply the amount for.
     */
    multiply(factor) {
        const newAmount = decimal_js_1.Decimal.mul(factor, this.amount).toNumber();
        return new Money(newAmount, this.currency);
    }
    get smallestUnit() {
        return decimal_js_1.Decimal.div(this.amount, enums_1.SmallestCurrencyUnit[this.currency]).toNumber();
    }
    toString() {
        return this.amount.toLocaleString(undefined, {
            style: 'currency',
            currency: this.currency,
        });
    }
}
exports.Money = Money;
//# sourceMappingURL=Money.js.map